import { provideEffects } from '@ngrx/effects';
import { ActionReducer, provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { AppModel, appReducer, serversReducer, ServersPageModel } from '@cue-admin/shared-data';
import { ServersEffects } from './effects/servers.effects';

export const coreProviders = [
  provideStore(
    {
      app: appReducer as ActionReducer<AppModel>,
      serversPage: serversReducer as ActionReducer<ServersPageModel>,
    },
    {
      runtimeChecks: {
        strictActionImmutability: false,
        strictActionSerializability: false,
        strictStateImmutability: false,
        strictStateSerializability: false,
      },
    }
  ),
  provideEffects([ServersEffects]),
  provideStoreDevtools({
    maxAge: 25,
    connectInZone: true,
  }),
];
